@if (!decision()) {
  <fol-decision-error />
} @else {
  <div class="title-container row center space-top-2">
    <h1>
      {{ `supporting_documents.${decision()?.toLowerCase()}.title` | translate }}
    </h1>
  </div>

  <div class="space-top-4">
    @if (decision() === DECISION_ENUM.RED) {
      <div>
        <span class="quit">{{ 'supporting_documents.r.trust' | translate }}</span>
      </div>
    }
    <div>
      <span class="quit">{{
        `supporting_documents.${decision()?.toLowerCase()}.text${translationKeySuffix}` | translate
      }}</span>
    </div>

    <div>
      <div class="display-flex">
        <p>
          {{ `supporting_documents.${decision()?.toLowerCase()}.subtitle${translationKeySuffix}` | translate }}
        </p>
        @if (decision() === DECISION_ENUM.RED && !isCreditModerne) {
          <ml-popin-trigger
            [title]="'supporting_documents.r.popin-title' | translate"
            [buttonText]="'supporting_documents.r.popin-close' | translate">
            <ml-icon trigger iconName="info"></ml-icon>
            <p>
              {{ 'supporting_documents.r.information-link' | translate }}&nbsp;<a
                rel="noopener"
                href="https://asset.mediahub.bnpparibas/is/content/bnpparibas/DPN%20V3%20PF%20sans%20option%20clause%2008042022%20PF%2017052022"
                target="_blank"
                >{{ 'supporting_documents.r.notice-information' | translate }}</a
              >&nbsp;{{ 'supporting_documents.r.information' | translate }}
            </p>
          </ml-popin-trigger>
        }
      </div>
      @if (decision() !== DECISION_ENUM.RED) {
        <div class="column center step-wrapper space-top-1 gap-1">
          @for (step of steps(); track step; let i = $index) {
            <fol-step
              [num]="i + 1"
              [title]="'stepper.steps.' + step.toLowerCase() | translate"
              [validated]="validatedSteps().includes(step)"
              [active]="isCreditModerne ? step === STEP.COUNSELOR_RECONTACT : step === STEP.SUPPORTING_DOCUMENTS" />
          }
        </div>
      }
    </div>
  </div>
}
